import { createRoutePlaceholder } from '../../components/RoutePlaceholder';
export default createRoutePlaceholder();
